import type { MailServer, MailProvider, MailProviderDefaults, SmtpAuthEncryption, MailServerStatus } from "./types";

export const mailProviders: Partial<Record<MailProvider, MailProviderDefaults>> = {
    microsoft: {
        displayName: 'Microsoft Exchange',
        host: 'smtp.office365.com',
        port: 587,
        encryption: 'tls',
        requireOAuth: true,
    },
    google: {
        displayName: 'Google',
        host: 'smtp.gmail.com',
        requireAppPassword: true,
        appPasswordLink: 'https://support.google.com/mail/answer/185833?hl=de',
    },
    yahoo: {
        displayName: 'Yahoo!',
        host: 'smtp.mail.yahoo.com',
        requireAppPassword: true,
        appPasswordLink: 'https://de.hilfe.yahoo.com/kb/SLN15241.html',
    },
    icloud: {
        displayName: 'iCloud',
        host: 'smtp.mail.me.com',
        requireAppPassword: true,
        appPasswordLink: 'https://support.apple.com/de-de/102654',
    },
    other: {
        displayName: 'Anderer E-Mail Anbieter',
    }
}

export const getMailProviderDefaults = (provider: MailProvider): MailProviderDefaults | undefined => {
    return mailProviders[provider];
}

export const makeMailServer = (mailServer?: Partial<MailServer>): MailServer => ({
    id: -1,
    from_name: '',
    from_address: '',
    username: '',
    password: '',
    encryption: "tls",
    status: 'disabled',
    port: 587,
    ...mailServer,
});

export const encryptionItems: { title: string, value: SmtpAuthEncryption }[] = [
    { title: 'TLS/STARTTLS', value: 'tls' },
    { title: 'SSL', value: 'ssl' },
];

export const mailServerHeaders = [
    { title: 'Status', key: 'status', sortable: false },
    { title: 'Name', key: 'from_name', sortable: false },
    { title: 'E-Mail Adresse', key: 'from_address', sortable: false },
    { title: 'Host', key: 'host', sortable: false },
    { title: 'Port', key: 'port', sortable: false },
    {
        title: 'Verschlüsselung',
        key: 'encryption',
        sortable: false,
        value: (mailServer: MailServer) => encryptionItems.find(item => {
            return item.value === mailServer.encryption;
        })?.title,
    },
];

export const getMailServerStatusText = (status: MailServerStatus) => {
    switch(status) {
        case 'connected': return 'Verbunden';
        case 'unreachable': return 'Verbindung fehlgeschlagen';
        case 'disabled': return 'Dein Mailserver wurde aufgrund von Verbindungsproblemen deaktiviert';
    }
}

export const getMailProviderFromHost = (host?: string): MailProvider => {
    const provider = Object.entries(mailProviders).find(provider => {
        return provider[1].host === host;
    });

    return provider ? provider[0] as MailProvider : 'other';
}

/**
 * Map frontend provider names to backend OAuth provider keys.
 */
export const oauthProviderMap: Partial<Record<MailProvider, string>> = {
    microsoft: 'microsoft',
};
